import { logger } from '../logger.js';

// internal reference; starts out undefined
let bus;
const setEventEmitter = (emitter) => {
    bus = emitter;
};
const emitEvent = (type, data) => {
    if (!bus) {
        logger.error("EventEmitter not set!");
        return;
    }
    bus.emit(type, data);
};

export { emitEvent, setEventEmitter };
//# sourceMappingURL=emitter.js.map
